/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ProtocolTitle/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function ProtocolTitle({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/DentalMonitoring/Content/Started/ProtocolTitle"
  
}) {
let constantData = 'Protocol:'
let dentalMonitoringPatientMonitoringConfigProtocolTitleValueData = fromData.useDataValue({ viewPath,
context: 'dental_monitoring',
path: 'patient.monitoring.config.protocol_title',
})
let aggregateData = fromAggregate.join(constantData, dentalMonitoringPatientMonitoringConfigProtocolTitleValueData)
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceS}
 data="'Protocol:'"
 data="dental_monitoring.patient.monitoring.config.protocol_title"
 aggregate="/Simple/Data/aggregate.js join"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}